import { c as _c } from "react/compiler-runtime";
import { automationRuleDependencies } from 'modules/automation-rules/constants/automation-rule-dependencies';
import { AutomationRuleApiInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export const useStoreOptinRules = optinId => {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const t1 = `/api/dashboard/customer/digital-store/item-optin/${optinId}/automation-rules`;
  let t2;
  if ($[1] !== t1) {
    t2 = [t1, ...automationRuleDependencies];
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return useControlledSwr(t2, fetcher, t3, !!user);
};